import { makeStyles, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableRow, Tabs, Typography } from "@material-ui/core"
import React, { useState } from "react"
import { TabPanel } from "./AppEn"

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        height: '100%',
    },
    table: {
        maxWidth: 900,
    },
    tabs: {
        borderRight: `1px solid ${theme.palette.divider}`,
    },
}))

export const EnotitesEn = () => {
    const classes = useStyles()

    return (
        <React.Fragment>
            <Typography variant='h5'>Work Packages</Typography>
            <ul>
                <li>
                    <Typography align='justify'>
                        <b>WP1.</b> Collection, registration and categorization of samples from Greek olive tree varieties
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP2.</b> Development and application of validated methodologies for the traceability of selected olive varieties
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP3.</b>Development and application of validated methodologies to characterize the debittering method of edible olive samples
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP4.</b>Development and application of validated methodologies to verify the health claim in olive oil meeting the EFSA criteria. Finding optimal conditions for olive oil production and developing a specialized olive oil production protocol
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP5.</b> Development and application of validated methodologies for quality assurance of PDO, PGI olive oils
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP6.</b> Creation and establishment of quality control systems for the authenticity of olive-based products
                    </Typography>
                </li>
                <li>
                    <Typography align='justify'>
                        <b>WP7.</b> Promotion of authenticated olive-based products at the International Trade Shows
                    </Typography>
                </li>
            </ul>
        </React.Fragment>
    )
}